/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const SendRotated = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2.67509 8.09331C2.08161 8.29921 1.6793 8.85311 1.66704 9.48117C1.65477 10.1092 2.03516 10.6784 2.62015 10.9073L10.1408 13.8502L13.0836 21.3708C13.3125 21.9557 13.8817 22.3361 14.5097 22.3239C15.1378 22.3116 15.6917 21.9093 15.8976 21.3158L21.908 3.9917C22.0964 3.4487 21.9579 2.84579 21.5515 2.43938C21.1451 2.03297 20.5422 1.89452 19.9992 2.08291L2.67509 8.09331ZM11.5968 13.4547L14.4805 20.8242L20.4909 3.50004L3.16675 9.51045L10.5361 12.3941L16.0714 6.85881L17.132 7.91947L11.5968 13.4547Z"
                        fill={color}
                    />
                </svg>
        );
    };
